export default __webpack_public_path__ + "static/media/4.b9391a57.jpg";